import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import Link from '../Link'

import Button from '../Button/'

import {
  rightArrow,
  ctaContainer,
  titleText,
  bodyText,
  linkText,
  twoThirdsCalloutContainer,
  ctaWrapper,
  imageWrapper,
  ctas,
  left,
  right,
} from './index.module.css'

const CTA = ({ cta }) => {
  const { title, subtitle, ctaUrl, ctaText, ctaDefaultDisplay } = cta

  const renderLink = () =>
    ctaDefaultDisplay ? (
      <span>
        {ctaText} <i className={rightArrow} />
      </span>
    ) : (
      <Button inverted>
        <span>
          {ctaText} <i className={rightArrow} />
        </span>
      </Button>
    )

  return (
    <div className={ctaContainer}>
      <h2 className={titleText}>{title}</h2>
      <p className={bodyText}>{subtitle?.subtitle}</p>
      {ctaText && (
        <Link className={linkText} to={ctaUrl}>
          {renderLink()}
        </Link>
      )}
    </div>
  )
}

const TwoThirdsCallout = ({ components, images, imageTextPosition }) => {
  const imagePositionClass =
    imageTextPosition !== null && imageTextPosition === 'left' ? left : right
  const image = images[0]
  return (
    <div className={twoThirdsCalloutContainer}>
      <div className={`${ctaWrapper} ${imagePositionClass}`}>
        <div className={imageWrapper}>
          <GatsbyImage image={image.iphero} alt={image?.description} />
        </div>
        <div className={ctas}>
          {components.map((block) => (
            <CTA cta={block} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default TwoThirdsCallout
